<template>
  <ul class="nav-list" :class="{ selected: isSelected() }">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: "NavList",
  methods: {
    isSelected: function () {
      return this.$parent.onMouse !== "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.nav-list {
  z-index: 100;
  &.selected {
    margin-top: -4px;
  }
}
</style>
